export const formStates = {
  start: {availableStates: ["enter-phone"], nextState: "enter-phone"},

};

export function getNextState(state) {
  return formStates[state]?.nextState ?? formStates[state]?.availableStates?.[0] ?? state;
}

export const states = ['start',]
